<template>
  <div>
    <div class="row">
      <v-col cols="12" sm="12">
        <div>
          <span class="mr-2"
            ><b style="color: yellow">SALES TOTALS: </b>$
            {{
              lastDayPurchase.reduce((a, b) => a + b.total, 0) | formatMoney
            }}</span
          >
          <span class="mr-2"
            ><b style="color: yellow">Chip: </b>$
            {{
              lastDayPurchase.reduce((a, b) => a + b.chipTotal, 0) | formatMoney
            }}</span
          >
          <span class="mr-2"
            ><b style="color: yellow">Gold: </b>$
            {{
              lastDayPurchase.reduce((a, b) => a + b.goldTotal, 0) | formatMoney
            }}</span
          >
          <span class="mr-2"
            ><b style="color: yellow">Multi: </b>$
            {{
              lastDayPurchase.reduce((a, b) => a + b.multiTotal, 0)
                | formatMoney
            }}</span
          >
          <span class="mr-2"
            ><b style="color: yellow">Noel: </b>$
            {{
              lastDayPurchase.reduce((a, b) => a + b.noelTotal, 0) | formatMoney
            }}</span
          >
          <span class="mr-2"
            ><b style="color: yellow">Total Order: </b
            >{{
              lastDayPurchase.reduce((a, b) => a + b.totalOrder, 0)
                | formatMoney
            }}</span
          >
          <span class="mr-2"
            ><b style="color: yellow">Total Uniq Users: </b
            >{{
              lastDayPurchase.reduce((a, b) => a + b.uniqueUserCount, 0)
                | formatMoney
            }}</span
          >
          <span class="mr-2"
            ><b style="color: yellow">Total Order: </b
            >{{
              lastDayPurchase.reduce((a, b) => a + b.totalOrder, 0)
                | formatMoney
            }}</span
          >
          <span
            class="text-nowrap"
            :key="index"
            v-for="(item, index) in lastDayPurchase"
          >
            <b style="color: yellow"> {{ item.name }}:</b> $
            {{ item.total | formatMoney }}
          </span>
          <br />
        </div>
      </v-col>
    </div>
    <v-toolbar flat>
      <v-toolbar-title>Purchase</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-text-field
        v-model="search"
        label="Search"
        single-line
        v-on:keyup.enter="initialize"
        hide-details
      ></v-text-field>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-menu
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        :return-value.sync="dates"
        transition="scale-transition"
        offset-y
        min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-model="dates"
            label="Picker in menu"
            prepend-icon="mdi-calendar"
            readonly
            single-line
            hide-details
            v-bind="attrs"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker v-model="dates" locale="tr-TR" range no-title scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
          <v-btn text color="primary" @click="initialize"> OK </v-btn>
        </v-date-picker>
      </v-menu>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="$store.state.purchases.stateSelect"
        :items="states"
        item-value="id"
        item-text="value"
        @change="initialize"
        hide-details
        label="State"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="$store.state.purchases.platformSelect"
        :items="platforms"
        item-value="id"
        item-text="value"
        @change="initialize"
        hide-details
        label="Platform"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="$store.state.purchases.priceSelect"
        :items="prices"
        item-value="id"
        item-text="value"
        @change="initialize"
        hide-details
        label="Price"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="$store.state.purchases.dynamicOfferSelect"
        :items="offers"
        item-value="id"
        item-text="name"
        @change="initialize"
        hide-details
        label="Dynamic Offers"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="$store.state.purchases.productTypeSelect"
        :items="$store.state.homes.enumTypes.productType"
        item-value="value"
        item-text="id"
        @change="initialize"
        hide-details
        label="Product Type"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="$store.state.purchases.countrySelect"
        :items="$store.state.purchases.country"
        item-value="id"
        item-text="value"
        @change="initialize"
        hide-details
        label="Country"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-combobox
        v-model="$store.state.purchases.citySelect"
        :items="$store.state.purchases.city"
        :loading="$store.state.progress"
        item-value="id"
        item-text="value"
        @change="initialize"
        hide-details
        label="City"
      ></v-combobox>

      <v-divider class="mx-2" inset vertical></v-divider>

      <v-combobox
        v-model="pageItemSelect"
        :items="pageItems"
        item-value="id"
        item-text="value"
        @change="initialize"
        hide-details
        label="Page"
      ></v-combobox>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn color="primary" dark @click="initialize" class="mb-2"
        >Search</v-btn
      >
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn color="red" @click="exportCsv" dark target="_blank" class="mb-2"
        >Export Csv</v-btn
      >
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-btn
        color="green"
        @click="$store.dispatch('purchases/getRefundCheck')"
        dark
        target="_blank"
        class="mb-2"
        >Refund Sync</v-btn
      >
    </v-toolbar>
    <v-data-table
      :headers="headers"
      hide-default-footer
      :items-per-page="2000"
      :options.sync="options"
      :items="purchases.data"
      class="elevation-1"
    >
      <template v-slot:item.action="{ item }">
        <v-icon class="mr-2" @click="detail(item)">edit</v-icon>
      </template>
      <template v-slot:item.users.played="{ item }">
        <div v-if="item.users">
          {{ item.users.played.b[0] | getDateFormat }}
        </div>
      </template>
      <template v-slot:item.users.locationInfo.country_long="{ item }">
        <div style="display: flex">
          <v-avatar size="36" style="margin-right: 5px; margin-top: 3px">
            <v-img
              v-if="item.users && item.users.locationInfo"
              :src="`https://pokerface.restplay.com/flags/${item.users.locationInfo.country_short.toLocaleLowerCase()}.png`"
            />
          </v-avatar>
          <div v-if="item.users && item.users.deviceInfo.ipAdress">
            <span v-if="item.users.locationInfo">{{
              item.users.locationInfo.country_long
            }}</span>
            <div>{{ item.users.deviceInfo.ipAdress.split(",")[0] }}</div>
          </div>
        </div>
      </template>
      <template v-slot:item.type="{ item }">
        <v-avatar size="36" style="margin-right: 5px; margin-top: 3px">
          <v-img
            :src="`https://pokerface.restplay.com/product/${item.type}.png`"
          />
        </v-avatar>
        {{ item.type }}
      </template>
      <template v-slot:item.users.chipAmount="{ item }">
        <div v-if="item.users">
          {{ item.users.chipAmount | formatMoney }}
        </div>
      </template>
      <template v-slot:item.offerId="{ item }">
        <div v-if="item.offerId">
          {{ offers.find((m) => m.id == item.offerId).name }}
        </div>
      </template>
      <template v-slot:item.chip="{ item }">
        {{ item.chip | formatMoney }}
      </template>
      <template v-slot:item.totalChip="{ item }">
        {{ item.totalChip | formatMoney }}
      </template>
      <template v-slot:item.createdDate="{ item }">
        <div>{{ new Date(item.createdDate * 1000) | formatDate }}</div>
      </template>
      <template v-slot:item.users.id="{ item }">
        <UserDetailCard
          :userId="item.users.id"
          :pictureUrl="item.users.pictureUrl"
          :userName="item.users.userName"
          :level="item.users.levelInfo.l"
        />
      </template>
    </v-data-table>
    <div class="text-center pt-2">
      <v-pagination
        v-model="currentPage"
        :total-visible="20"
        @input="pageClick"
        :length="purchases.totalPage"
      ></v-pagination>
    </div>
    <v-row justify="center">
      <v-dialog v-model="dialog" max-width="1600px">
        <v-card>
          <v-card-title>
            <span class="headline">User Profile</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="$store.state.purchases.detail.id"
                    label="Legal first name*"
                    required
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="$store.state.purchases.detail.id"
                    label="Id"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="$store.state.purchases.detail.chip"
                    label="Chip"
                  ></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="$store.state.purchases.detail.price"
                    label="Price"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-if="$store.state.purchases.detail.users"
                    v-model="$store.state.purchases.detail.users.id"
                    label="userId"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-if="$store.state.purchases.detail.users"
                    v-model="$store.state.purchases.detail.users.userName"
                    label="userName"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
            <json-viewer
              name="df"
              :value="$store.state.purchases.detail.data"
              :expand-depth="5"
              theme="my-awesome-json-theme"
              sort
            ></json-viewer>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false"
              >Close</v-btn
            >
            <v-btn color="blue darken-1" text @click="dialog = false"
              >Save</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "DetailCard",
  props: {
    search: {
      type: String,
      description: "purchases",
    },
  },
  components: {
    UserDetailCard: () => import("@/components/Users/UserDetailCard.vue"),
  },
  data() {
    return {
      options: {},
      dates: [
        new Date(Date.now()).addDays(-365).toISOString().substr(0, 10),
        new Date(Date.now()).toISOString().substr(0, 10),
      ],

      menu: false,
      dialog: false,
      currentPage: 1,
      lastDayPurchase: [],
      purchases: {},

      platforms: [
        { id: "", value: "All" },
        { id: "android", value: "Android" },
        { id: "ios", value: "Ios" },
        { id: "facebook", value: "Facebook" },
      ],
      offers: [{ id: null, name: "All" }],
      states: [
        { id: "", value: "All" },
        { id: "refund", value: "Refund" },
        { id: "error", value: "Error" },
        { id: "completed", value: "Completed" },
      ],
      pageItemSelect: { id: 50, value: "50" },

      pageItems: [
        { id: 50, value: "50" },
        { id: 100, value: "100" },
        { id: 250, value: "250" },
        { id: 500, value: "500" },
        { id: 1000, value: "1000" },
        { id: 2000, value: "2000" },
        { id: 5000, value: "5000" },
      ],
      prices: [
        { id: -1, value: "All" },
        { id: 1.49, value: "1.49" },
        { id: 2.99, value: "2.99" },
        { id: 3.75, value: "3.75" },
        { id: 4.99, value: "4.99" },
        { id: 7.49, value: "7.49" },
        { id: 7.99, value: "7.99" },
        { id: 9.99, value: "9.99" },
        { id: 14.99, value: "14.99" },
        { id: 14.99, value: "14.99" },
        { id: 19.99, value: "19.99" },
        { id: 37.49, value: "37.49" },
        { id: 49.99, value: "49.99" },
        { id: 74.99, value: "74.99" },
        { id: 99.99, value: "99.99" },
        { id: 149.99, value: "149.99" },
      ],
      headers: [
        { text: "User", value: "users.id" },
        {
          text: "Id",
          value: "id",
        },
        { text: "Product Type", value: "type" },
        { text: "Dynamic Offers", value: "offerId" },
        { text: "Platform", value: "platform" },
        { text: "Chip", value: "chip" },
        { text: "TotalChip", value: "totalChip" },
        { text: "Price", value: "price" },
        { text: "Chip Amount", value: "users.chipAmount" },
        { text: "Play Time", value: "users.played" },
        { text: "Created Date", value: "createdDate" },
        { text: "Location Info", value: "users.locationInfo.country_long" },
        { text: "State", value: "state" },
        { text: "Actions", value: "action", sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        if (this.options.sortBy.length > 0) this.initialize();
      },
      deep: true,
    },
  },
  methods: {
    pageClick(a) {
      this.currentPage = a;
      this.initialize();
    },
    async initialize() {
      await this.$store.dispatch("dynamicOffers/getAll");
      this.offers = [...this.offers, ...this.$store.state.dynamicOffers.all];
      this.endDate =
        new Date(
          new Date(this.dates[1]).getTime() +
            new Date().getTimezoneOffset() * 60000
        ) / 1000;
      // if (!this.dates[1])
      //   this.endDate = parseInt(
      //     new Date(Date.now()).addDays(1).getTime() / 1000
      //   );

      this.$refs.menu.save(this.dates);
      this.$store
        .dispatch("purchases/getPlatformTotalSalesQuery", {
          search: this.search,
          startDate:
            new Date(
              new Date(this.dates[0]).getTime() +
                new Date().getTimezoneOffset() * 60000
            ) / 1000,
          endDate: this.endDate,
        })
        .then((m) => (this.lastDayPurchase = m));

      this.purchases = await this.$store.dispatch("purchases/getAll", {
        page: this.currentPage - 1,
        size: this.pageItemSelect.id,
        search: this.search,
        options: this.options,
        startDate:
          new Date(
            new Date(this.dates[0]).getTime() +
              new Date().getTimezoneOffset() * 60000
          ) / 1000,
        endDate: this.endDate,
      });
    },
    exportCsv() {
      var startDate =
        new Date(
          new Date(this.dates[0]).getTime() +
            new Date().getTimezoneOffset() * 60000
        ) / 1000;
      var endDate = new Date(this.dates[1]).addDays(1).getTime() / 1000;
      if (!endDate) endDate = startDate;
      let url = JSON.parse(localStorage.getItem("selectEnvironment")).url;

      url += `/product/purchases/CsvExport?startDate=${startDate}&endDate=${endDate}&q=${
        this.search
      }&p=${this.currentPage - 1}&t=50`;
      if (this.$store.state.purchases.citySelect.id != "0")
        url += `&city=${this.$store.state.purchases.citySelect.id}`;
      if (this.$store.state.purchases.countrySelect.id != "0")
        url += `&country=${this.$store.state.purchases.countrySelect.id}`;
      if (this.$store.state.purchases.priceSelect.id > -1)
        url += `&price=${this.$store.state.purchases.priceSelect.id}`;
      if (this.$store.state.purchases.productTypeSelect.value > -1)
        url += `&productType=${this.$store.state.purchases.productTypeSelect.value}`;
      if (this.$store.state.purchases.platformSelect.id != "")
        url += `&platform=${this.$store.state.purchases.platformSelect.id}`;
      if (this.options.sortBy[0])
        url += `&sortBy=${this.options.sortBy[0]}&sortDesc=${this.options.sortDesc[0]}`;

      window.open(url, "_blank");
    },
    async detail(item) {
      await this.$store.dispatch("purchases/get", item.id);
      this.dialog = true;
    },
  },
  async mounted() {
    await this.initialize();
  },
};
</script>
